/* Copyright 2019 Ellucian Company L.P. and its affiliates.
 * File: PaymentOrigin.ts */

export enum PaymentOrigin {
    Registration = 0,
    ConEdRegistration = 1,
    MakePayment = 2,
    TranscriptRequest = 3,
    OnlineDonation = 4,
    Application = 5,
    PowerCampusReceipt = 6,
    PowerCampusGift = 7,
    SharedAccessMakePayment = 8
}